<template>
    <a-modal :title="`佣金提现`" :width="600" :open="true" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">关闭</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button type="primary" :loading="state.submitLoading">提交</a-button>
            </a-popconfirm>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 10 }">
            <a-form ref="ruleForm" :model="formData" style="width: 600px; margin-top: 30px" v-bind="formLayout"
                v-if="state.tixianData">
                <a-form-item label="提现金额"> ￥{{ state.tixianData.money }}元 </a-form-item>
                <a-form-item label="订单笔数"> ￥{{ state.tixianData.order_num }}笔 </a-form-item>
                <a-form-item label="平台名称"> {{ state.tixianData.platform_name }} </a-form-item>
                <a-form-item label="打款方式" name="payment_method" required>
                    <a-radio-group v-model:value="formData.payment_method" button-style="solid">
                        <a-radio-button :value="1">对公打款</a-radio-button>
                        <a-radio-button :value="2">直接到账</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <div v-if="formData.payment_method == 1">
                    <a-form-item label="银行名称" name="bank_name" required>
                        <a-input v-model:value="formData.bank_name" placeholder="请输入银行名称" style="width: 320px">
                        </a-input>
                    </a-form-item>
                    <a-form-item label="银行卡号" name="bank_card_num" required>
                        <a-input v-model:value="formData.bank_card_num" placeholder="请输入银行卡号" style="width: 320px">
                        </a-input>
                    </a-form-item>
                    <a-form-item label="开户行" name="bank_open_addr" required>
                        <a-input v-model:value="formData.bank_open_addr" placeholder="请输入开户行" style="width: 320px">
                        </a-input>
                    </a-form-item>
                    <a-form-item label="附件" name="attachment">
                        <Upload :upload_path="`public/uploads/manage/财务管理/推荐人提现/推荐人申请/${dayjs().format('YYYYMM')}/`"
                            :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']" uploadType="text"
                            v-model:value="formData.attachment" :limitation="99" uploadText="上传附件">
                        </Upload>
                    </a-form-item>
                </div>
                <a-form-item label="备注">
                    <a-input v-model:value="formData.remark" placeholder="请输入备注（可填）" style="width: 320px">
                    </a-input>
                </a-form-item>
                <a-form-item> 说明：公司个体户提供发票，全额打款，个人代开发票过来，根据税法，代扣代缴20%个人所得税，慎用个人代开发票。 </a-form-item>
            </a-form>
        </a-skeleton>
    </a-modal>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, onMounted, ref } from 'vue'
import Upload from '@/components/base/Upload.vue'
import dayjs from 'dayjs'
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
    }
}
const ruleForm = ref()
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    platformId: {
        type: Number,
        default: 0
    }
})
interface IState {
    loading: boolean
    submitLoading: boolean
    tixianData: any
}
const state = reactive<IState>({
    loading: false,
    submitLoading: false,
    tixianData: {}
})
interface IformData {
    payment_method: number
    bank_name: string
    bank_card_num: string
    bank_open_addr: string
    attachment: any
    remark: string
}
const formData = reactive<IformData>({
    payment_method: 1,
    bank_name: '',
    bank_card_num: '',
    bank_open_addr: '',
    attachment: [],
    remark: ''
})
onMounted(() => {
    loadData()
})
// 获取平台数据
const loadData = () => {
    // 获取到列表数据
    state.loading = true
    let requestParam = {
        url: '/admin/v1/dealerTixian/create',
        method: 'post',
        data: {
            platform_id: props.platformId
        }
    }
    baseService(requestParam)
        .then((res) => {
            state.tixianData = res.data
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('平台列表查询失败,请联系管理员')
            }
        }).finally(() => {
            state.loading = false
        })
}
// 提交
const onFormSubmit = () => {
    state.submitLoading = true
    ruleForm.value
        .validate()
        .then((res) => {
            let requeryParam = {
                url: '/admin/v1/dealerTixian/store',
                method: 'post',
                data: { ...formData, platform_id: props.platformId, money: state.tixianData.money }
            }
            baseService(requeryParam)
                .then((res: any) => {
                    message.success(res.msg)
                    state.submitLoading = false
                    emit('ok')
                })
                .catch((res) => {
                    state.submitLoading = false
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                }).finally(() => {
                    state.submitLoading = false
                })
        })
        .catch((res) => {
            state.submitLoading = false
            message.warn('请检查必填项')
        })
}
const cancel = () => {
    emit('cancel')
}
</script>

<style lang="less" scoped></style>
